function nextEntityWithNumberNameGenerator(items, defaultName) {
    let numbers = [0];
    let generalName = defaultName;
    let itemsWithNumbers = [];

    if (items.length > 0) {
        let firstItem = items[0];
        generalName = firstItem;


        for (let i = 0; i < items.length; i++) {
            if (items[i].lastIndexOf('#') > 0) {
                itemsWithNumbers.push(items[i]);
            }
        }

        firstItem = itemsWithNumbers.length > 0 ? itemsWithNumbers[0] : firstItem;

        if (firstItem.lastIndexOf('#') > 0) {
            generalName = firstItem.substr(0, firstItem.lastIndexOf('#') - 1);
        }
    }

    for (var i = 0; i < items.length; i++) {
        if (items[i].match(/^[\D\s]*\s#\d/ig)) {
            numbers.push(+items[i].match(/\d*$/ig)[0]);
        }
    }
    numbers = numbers.sort((a, b) => a - b).reverse();

    return `${generalName} #${+numbers[0] + 1}`;
}

export default nextEntityWithNumberNameGenerator;
